import { AlertTriangle } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import type { NoticeCode } from '@/types/support-assistant';

export interface NoticeBannerProps {
  code: NoticeCode;
  retryAfter?: string;
  ticketNumber?: string;
}

export function NoticeBanner({ code, retryAfter, ticketNumber }: NoticeBannerProps) {
  const { t } = useTranslation();

  let text: string;
  if (code === 'rate_limit') {
    const date = retryAfter ? new Date(retryAfter) : null;
    text =
      date && !Number.isNaN(date.getTime())
        ? t('assistant.notice.rate_limit', {
            time: date.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' }),
          })
        : t('assistant.notice.rate_limit_generic');
  } else {
    text = t(`assistant.notice.${code}`, { id: ticketNumber ?? '' });
  }

  return (
    <div
      role="status"
      className="flex items-start gap-2 rounded-[8px] bg-[var(--background-badge-red)] p-4 text-[14px] leading-[1.5] text-[var(--text-content-title)]"
    >
      <AlertTriangle
        aria-hidden="true"
        className="mt-0.5 h-4 w-4 shrink-0 text-[var(--color-maroon)]"
      />
      <p>{text}</p>
    </div>
  );
}
